import WatchBox from "../components/WatchBox/WatchBox"
import Footer from "../components/Footer/Footer"

function Watch(){
    return(
        <>
            <WatchBox/>
        </>
    )
}

export default Watch